import React from "react";
import { ContinueButton, ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { TransferScanModal } from "./TransferScanModal";

export interface TransferScanErrorModalProps {
  title: string;
  text: string;
  hideModalValue: TransferScanModal;
}

export const TransferScanErrorModal: React.FC<TransferScanErrorModalProps> = ({ title, text, hideModalValue }) => {
  const { hideModal } = useSortationModal();
  return (
    <ModalTemplate
      title={<FormattedMessage id="sortation.transferScan.errorModalTitle" defaultMessage={title} />}
      text={<FormattedMessage id="sortation.transferScan.errorModalText" defaultMessage={text} />}
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
    >
      <ContinueButton block onClick={() => hideModal(hideModalValue)} />
    </ModalTemplate>
  );
};
